import { render, staticRenderFns } from "./ProRiskForm.vue?vue&type=template&id=9f277560&"
import script from "./ProRiskForm.vue?vue&type=script&lang=ts&"
export * from "./ProRiskForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProRiskForm.vue?vue&type=style&index=0&id=9f277560&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports